export const twoFactorLoginFormStyles = {
  icon: {
    display: 'flex',
    margin: '0 auto',
    height: '60px',
    width: '60px',
  },

  buttonWrapper: {
    display: 'flex',
    justifyContent: 'space-evenly',
    gap: '24px',
    marginTop: '32px',
  },
};
